/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { Dashboard as DashboardLayout } from 'layouts';
import {
  Box,
  Breadcrumbs,
  Grid2,
  Typography,
  Link as LinkMaterial,
  Tooltip,
  Button,
  DialogActions,
  TextField,
  Radio,
  FormControlLabel,
  RadioGroup,
  FormLabel,
  FormControl,
  MenuItem,
  Select,
  InputAdornment,
  DialogContent,
  Chip,
  DialogTitle,
  Dialog,
  SpeedDial,
  SpeedDialAction,
  IconButton,
} from '@mui/material';
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  fpValidation,
  getComparativeYearConsume,
  getDayWithMostConsume,
  getGeneralConsume,
  getGeneralReport,
  getHistoricalReport,
  getMonthWithMostConsume,
  getPeriodReport,
  getReceipt,
  getVoltage,
  sendReceipByPeriod,
} from 'js/actions/chargeDashboardActions';
import {
  BarChart,
  Card,
  ComparativeYearConsumeChart,
  MostConsumeChart,
} from 'components';
import {
  ArrowLeft,
  ArrowRight,
  AttachMoney,
  FlashOn,
  InsertPhoto,
  PictureAsPdf,
  Print,
  Receipt,
  TrendingUp,
} from '@mui/icons-material';
import { useIntl } from 'react-intl';
import DayWithMostConsumeChart from 'components/DayWithMostConsumeChart';
import { Dashboard } from 'components/ComparativeYearConsumeChart';
import DailyDemandReport from './DailyDemandReport';
import GeneralReport from './GeneralReport';
import { getWeatherInRange } from 'js/actions/meterActions';
import Voltage from './Voltage';
import DailyConsumptionReport from './DailyConsumptionReport';
import TotalsPerDay from './TotalsPerDay';
import OperationTime from './OperationTime';
import AveragePerWeek from './AveragePerWeek';
import TotalsPerTariff from './TotalsPerTariff';
import DailyConsume from './DailyConsume';
import ConsumeAccumulate from './ConsumeAccumulate';
import Weather from './Weather';
import Electric from './Electric';
import Current from './Current';
import { isAllowed } from 'helpers';
import theme from 'theme';
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es, enUS as en } from 'date-fns/locale';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AlertCard from './AlertCard';
import { getFpAvgPerMonth } from 'js/actions/meterDashboardActions';
import { PDF } from 'icons/PDF';
import { ShareButton } from 'components/Download';

export default function ChargeDashboardSolar() {
  const { state } = useLocation();
  const { groupId, chargeId } = useParams();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { meter, group } = state;
  const { charge } = state;
  const { rate_horary } = charge;
  const [FPid, setFPid] = useState(null);
  const [FPdata, setFPdata] = useState([]);
  const [heatMap, setHeatMap] = useState({ fee: true, hm: false });
  const [valueInfo, setValueInfo] = useState({ kwh: true, money: false });
  const localeNav = useSelector((state) => state.prefs.locale);
  const {
    comparativeYearConsume,
    dayMostConsume,
    generalConsumes,
    generalReport,
    historicalReport,
    monthMostConsume,
    receipt,
    byPeriod,
    loading,
    angle,
  } = useSelector((state) => state.chargeDashboard);
  const corpId = generalConsumes.concentrator_id;
  const concentrator_id = charge.id_data
    ? charge?.id_data?.substring(0, charge.id_data.indexOf('_'))
    : corpId;
  const fp = useSelector((state) => state.chargeDashboard.fpValidation);
  const user = useSelector((state) => state.user.user);
  const { weather } = useSelector((state) => state.meters);
  const [chargeVoltageId, setChargeVoltageId] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());
  const [currentMonth, setCurrentMonth] = useState(
    new Date().getMonth() + 1 <= 9
      ? `0${new Date().getMonth() + 1}`
      : new Date().getMonth() + 1
  );
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [openModal, setOpenModal] = useState(false);
  const [value, setValue] = useState('historical');
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [formatPhone, setFormatPhone] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [country, setCountry] = useState('mexico');
  const [showInfo, setShowInfo] = useState(false);
  const [sendEmail, setSendEmail] = useState('no');
  const captureRef = useRef();
  const navigate = useNavigate();
  const corporative = state?.corporative;

  const locale = localeNav === 'es-MX' ? es : en;

  const formatDate = (date) => {
    const padToTwoDigits = (num) => {
      return num.toString().padStart(2, '0');
    };
    const day = padToTwoDigits(date.getDate());
    const month = padToTwoDigits(date.getMonth() + 1);
    const year = date.getFullYear();

    return `${year}${month}${day}`;
  };

  const totalConsumeskW =
    generalReport.totals_per_horary_kw === undefined
      ? [0, 0, 0]
      : rate_horary === 1
        ? Object.values(generalReport.totals_per_horary_kw).map((valor) => {
            if (typeof valor === 'string') {
              return parseFloat(valor.replace(/,/g, ''));
            } else {
              return valor;
            }
          })
        : [
            Math.max(
              ...Object.values(generalReport.totals_per_horary_kw).map(
                (value) => parseFloat(String(value).replace(/,/g, ''))
              )
            ),
          ];

  const totalConsumeskWh =
    generalReport?.totals_per_horary === undefined
      ? [0, 0, 0]
      : rate_horary === 1
        ? Object.values(generalReport.totals_per_horary).map((valor) => {
            if (typeof valor === 'string') {
              return parseFloat(valor.replace(/,/g, ''));
            } else {
              return valor;
            }
          })
        : [
            Object.values(generalReport.totals_per_horary).reduce(
              (sum, value) => sum + parseFloat(String(value).replace(/,/g, '')),
              0
            ),
          ];

  useEffect(() => {
    dispatch(
      getGeneralReport(
        { concentratorId: concentrator_id, chargeId },
        year,
        currentMonth
      )
    );
    dispatch(getGeneralConsume(chargeId, year, currentMonth));
    dispatch(
      getMonthWithMostConsume(
        { concentratorId: concentrator_id, chargeId },
        year,
        currentMonth
      )
    );
    dispatch(
      getComparativeYearConsume(
        { concentratorId: concentrator_id, chargeId },
        year,
        currentMonth
      )
    );
    dispatch(
      getDayWithMostConsume(
        { concentratorId: concentrator_id, chargeId },
        year,
        currentMonth
      )
    );
    dispatch(getHistoricalReport(chargeId));
  }, [charge, concentrator_id, year, currentMonth, chargeId, dispatch]);

  useEffect(() => {
    dispatch(getVoltage(chargeId, configVoltageChage));
  }, [chargeId, dispatch]);

  useEffect(() => {
    dispatch(fpValidation(chargeId));
  }, [chargeId, dispatch]);

  useEffect(() => {
    const startDate = '' + year + currentMonth;
    if (fp) {
      dispatch(getFpAvgPerMonth(fp.charge_fp, startDate, getFpData));
    }
  }, [fp, year, currentMonth]);

  const getFpData = (data) => {
    if (data) {
      setFPdata(data);
    }
  };

  useEffect(() => {
    const date_end = currentMonth
      ? new Date(year, currentMonth, 0)
      : new Date();
    const date_start = currentMonth
      ? new Date(year, currentMonth - 1, 1)
      : new Date(date_end.getFullYear(), date_end.getMonth(), 1);

    if (meter.id !== undefined) {
      dispatch(
        getWeatherInRange(
          corporative ? corporative.id : meter.corporative_id,
          meter.id,
          formatDate(date_start),
          formatDate(date_end)
        )
      );
    }
  }, [meter, year, currentMonth, dispatch]);

  const configVoltageChage = (data) => {
    if (!data) {
      setChargeVoltageId(null);
      return;
    }
    if (data.has_voltage == 1) {
      setChargeVoltageId(data.charge_voltage);
    } else {
      setChargeVoltageId(null);
    }
  };

  const voltageValidation = chargeVoltageId ? 4 : 6;

  useEffect(() => {
    if (rate_horary === 1) {
      setHeatMap({ fee: true, hm: false });
    } else {
      setHeatMap({ fee: false, hm: true });
    }
  }, [rate_horary]);

  const handleNavigation = () => {
    navigate(`/chargeDashboard/group/${groupId}/charge/${chargeId}/trend`, {
      state: { meter: meter, group: group, charge: charge },
    });
  };

  // 🔹 Función para actualizar la fecha seleccionada
  const handleDateChange = (newValue) => {
    if (newValue) {
      setSelectedDate(newValue);
      setYear(newValue.getFullYear());
      const month = newValue.getMonth() + 1;
      setCurrentMonth(month < 10 ? `0${month}` : `${month}`);
    }
  };

  // 🔹 Ir al mes anterior
  const handlePrevMonth = () => {
    let newMonth = parseInt(currentMonth) - 1;
    let newYear = year;

    if (newMonth < 1) {
      newMonth = 12;
      newYear -= 1;
    }

    setYear(newYear);
    setCurrentMonth(newMonth < 10 ? `0${newMonth}` : `${newMonth}`);

    // 🔹 Actualiza selectedDate con el nuevo mes/año
    const newDate = new Date(newYear, newMonth - 1, 1);
    setSelectedDate(newDate);
  };

  // 🔹 Ir al mes siguiente
  const handleNextMonth = () => {
    let newMonth = parseInt(currentMonth) + 1;
    let newYear = year;

    if (newMonth > 12) {
      newMonth = 1;
      newYear += 1;
    }

    setYear(newYear);
    setCurrentMonth(newMonth < 10 ? `0${newMonth}` : `${newMonth}`);

    // 🔹 Actualiza selectedDate con el nuevo mes/año
    const newDate = new Date(newYear, newMonth - 1, 1);
    setSelectedDate(newDate);
  };

  const getReceiptData = (chargeId) => {
    let month = new Date().getMonth();
    let year = new Date().getFullYear();

    month++;
    if (month == 1) {
      month = 12;
      year--;
    } else {
      month = month - 1;
    }

    dispatch(getReceipt(chargeId, year, month));
  };

  const countryCodes = {
    colombia: { code: '+57', maxLength: 10 },
    mexico: { code: '+52', maxLength: 10 },
  };

  const handleCountryChange = (event) => {
    setCountry(event.target.value);
    setFormatPhone('');
  };

  const handlePhoneChange = (event) => {
    const rawPhone = event.target.value.replace(/[^\d]/g, ''); // Eliminar caracteres no numéricos
    let formattedPhone = rawPhone;
    setPhone(countryCodes[country].code + rawPhone);

    // Formatear el número según el país seleccionado
    if (country === 'colombia') {
      formattedPhone = rawPhone.replace(
        /^(\d{3})(\d{3})(\d{4})$/,
        '($1) $2-$3'
      ); // Formato (NNN) NNN-NNNN
    } else if (country === 'mexico') {
      formattedPhone = rawPhone.replace(
        /^(\d{2})(\d{4})(\d{4})$/,
        '($1) $2-$3'
      ); // Formato (NN) NNNN-NNNN
    }

    // Limitar la longitud del número según el país
    if (rawPhone.length <= countryCodes[country].maxLength) {
      setFormatPhone(formattedPhone);
    }
  };

  const formatDateRecipt = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = `0${d.getMonth() + 1}`.slice(-2);
    const day = `0${d.getDate()}`.slice(-2);
    const hours = `0${d.getHours()}`.slice(-2);
    const minutes = `0${d.getMinutes()}`.slice(-2);
    const seconds = `0${d.getSeconds()}`.slice(-2);
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const handleModal = () => {
    setOpenModal(!openModal);
    setValue('historical');
    setStartDate(new Date());
    setEndDate(new Date());
    setFormatPhone('');
    setPhone('');
    setCountry('mexico');
    setShowInfo(false);
    setEmail('');
    setSendEmail('no');
  };

  const handleRadioChange = (event) => {
    setValue(event.target.value);
  };

  const handlePeriod = (event) => {
    event.preventDefault();

    // Validar que la fecha de inicio sea menor a la fecha de fin
    if (new Date(startDate) >= new Date(endDate)) {
      alert('La fecha de inicio debe ser menor que la fecha de fin.');
      return;
    }

    // Formatear las fechas antes de enviarlas
    const formattedStartDate = formatDateRecipt(startDate);
    const formattedEndDate = formatDateRecipt(endDate);

    dispatch(
      getPeriodReport(chargeId, formattedStartDate, formattedEndDate)
    ).then(() => setShowInfo(true));
  };

  const handleSendWhatsapp = () => {
    // Formatear las fechas antes de enviarlas
    const formattedStartDate = formatDateRecipt(startDate);
    const formattedEndDate = formatDateRecipt(endDate);

    dispatch(
      sendReceipByPeriod(
        chargeId,
        formattedStartDate,
        formattedEndDate,
        phone,
        email
      )
    )
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Reporte enviado con éxito',
        });
      })
      .then(() => handleModal());
  };

  const formattedMoney = (value) => {
    let numericValue = value;

    // Check if the value is a string and contains commas
    if (typeof value === 'string' && value.includes(',')) {
      // Remove commas from the string
      numericValue = value.replace(/,/g, '');
    }

    // Convert to a number (if it was a string)
    numericValue = parseFloat(numericValue);

    // Check if it's a valid number before formatting
    if (isNaN(numericValue)) {
      return 'Invalid Number'; // Or handle the error in another way
    }

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    return formatter.format(numericValue);
  };

  const validateEmail = () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const isButtonEnabled = () => {
    return (
      formatPhone.length >= countryCodes[country].maxLength ||
      (sendEmail === 'yes' && validateEmail())
    );
  };

  const handleReceipt = () => {
    if (currentMonth === null && year === null) {
      getReceiptData(chargeId);
    } else {
      dispatch(getReceipt(chargeId, year, parseInt(currentMonth)));
    }
  };

  const handlePDF = () => {
    setTimeout(() => {
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });

      Toast.fire({
        icon: 'info',
        title: 'Descargando...',
        text: 'Por favor espere',
      });

      html2canvas(captureRef.current, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'pt', [canvas.width, canvas.height - 750]);

        pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height - 750);
        pdf.save(`${charge.name}.pdf`);

        Toast.fire({
          icon: 'success',
          title: 'Descarga completa',
          text: 'Se ha descargado correctamente la gráfica',
        });
      });
    }, 100);
  };

  const handleCapture = async () => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    if (captureRef.current) {
      const canvas = await html2canvas(captureRef.current);
      const image = canvas.toDataURL('image/png');

      // Crear un enlace para descargar la imagen
      const link = document.createElement('a');
      link.href = image;
      link.download = `captura_${charge.name}.png`;
      link.click();
      Toast.fire({
        icon: 'success',
        title: 'Se ha Desacargado la Imagen',
      });
    } else {
      Toast.fire({
        icon: 'error',
        title: 'No se ha podido descargar la imagen',
      });
    }
  };

  return (
    <DashboardLayout
      handlePrevMonth={handlePrevMonth}
      handleNextMonth={handleNextMonth}
      currentMonth={currentMonth}
      year={year}
      selectedDate={selectedDate}
      handleDateChange={handleDateChange}
    >
      <Box p={4} ref={captureRef}>
        <Box
          display="flex"
          gap={2}
          flexDirection="row"
          alignItems="center"
          mb={2}
        >
          <Typography variant="h3" sx={{ color: '#A53693' }}>
            {intl.formatMessage({ id: 'app.charge.board.title' })}
          </Typography>
          <Button
            size="small"
            onClick={() => handlePDF()}
            color="secondary"
            variant="contained"
            sx={{
              color: 'white',
              fontWeight: 'bold',
              minWidth: '0',
              borderRadius: '50%',
              maxHeight: '35px',
              p: 0.5,
            }}
            aria-label="download"
          >
            <PDF />
          </Button>
          <ShareButton
            itemRef={captureRef}
            name={intl.formatMessage({ id: 'app.charge.board.title' })}
          />
        </Box>
        <AlertCard
          ids={{ groupId: groupId, chargeId: chargeId }}
          sx={{
            position: 'absolute',
            top: '.5%',
            right: '1%',
            [theme.breakpoints.down('lg')]: {
              right: '1.5%',
            },
            [theme.breakpoints.down('md')]: {
              right: '2.5%',
            },
            [theme.breakpoints.down('sm')]: {
              right: '4%',
              top: '.3%',
            },
          }}
        />
        {/** Inicio de Breadcrumb */}
        <Box display="flex">
          {isAllowed(user.permissions, ['corporative_read']) && meter && (
            <Breadcrumbs
              arial-label="breadcrumb"
              separator=":"
              sx={{ marginRight: theme.spacing(1) }}
            >
              <LinkMaterial
                color="inherit"
                component={NavLink}
                sx={{ color: '#A53693', textDecoration: 'none' }}
                to={`/corporative/${corporative ? corporative.id : meter.corporative_id}`}
                state={{
                  meter: meter,
                  corporative: corporative,
                }}
              >
                {intl.formatMessage({ id: 'app.groups.nav.meters' })}
              </LinkMaterial>
              <LinkMaterial
                color="inherit"
                component={NavLink}
                sx={{ textDecoration: 'none' }}
                to={`/meter/${meter.id}`}
                state={{
                  meter: meter,
                  corporative: corporative,
                }}
              >
                {meter
                  ? meter.name
                  : intl.formatMessage({ id: 'app.groups.nav.groupLab2' })}
              </LinkMaterial>
              <Typography sx={{ fontWeight: 600, color: '#00AFEF' }}>
                {' '}
                |{' '}
              </Typography>
            </Breadcrumbs>
          )}
          {meter && (
            <Breadcrumbs
              arial-label="breadcrumb"
              separator=":"
              sx={{ marginLeft: theme.spacing(1), color: '#A53693' }}
            >
              <LinkMaterial
                color="inherit"
                component={NavLink}
                to={`/meter/${meter.id}`}
                state={{
                  meter: meter,
                  corporative: corporative,
                }}
                sx={{ textDecoration: 'none' }}
              >
                {intl.formatMessage({ id: 'app.charges.nav.groupLab2' })}
              </LinkMaterial>
              <LinkMaterial
                component={NavLink}
                sx={{ textDecoration: 'none', color: '#66788A' }}
                to={`/group/${group.id}`}
                state={{
                  group: group,
                  meter: meter,
                  corporative: corporative,
                }}
              >
                {group
                  ? group.name
                  : intl.formatMessage({ id: 'app.charges.nav.chargeLab2' })}
              </LinkMaterial>
              <Typography sx={{ fontWeight: 600, color: '#00AFEF' }}>
                {' '}
                |{' '}
              </Typography>
            </Breadcrumbs>
          )}

          {meter ? (
            <Breadcrumbs
              arial-label="breadcrumb"
              separator=":"
              sx={{ marginLeft: theme.spacing(1), color: '#A53693' }}
            >
              <LinkMaterial
                color="inherit"
                component={NavLink}
                to={`/group/${group.id}`}
                state={{
                  group: group,
                  meter: meter,
                  corporative: corporative,
                }}
                sx={{ textDecoration: 'none' }}
              >
                {intl.formatMessage({
                  id: 'app.reports.hourReports.chargeLbl',
                })}
              </LinkMaterial>
              <Typography variant="h5">
                {charge
                  ? charge.name
                  : intl.formatMessage({ id: 'app.groups.nav.groupLab2' })}
              </Typography>
            </Breadcrumbs>
          ) : (
            <Breadcrumbs
              arial-label="breadcrumb"
              separator=":"
              sx={{ color: '#A53693' }}
            >
              <LinkMaterial
                color="inherit"
                component={NavLink}
                to={user.home_url}
                sx={{ textDecoration: 'none' }}
              >
                {intl.formatMessage({
                  id: 'app.reports.hourReports.chargeLbl',
                })}
              </LinkMaterial>
              <Typography variant="h5">
                {charge
                  ? charge.name
                  : intl.formatMessage({ id: 'app.groups.nav.groupLab2' })}
              </Typography>
            </Breadcrumbs>
          )}
        </Box>
        {/** Fin de Breadcrumb */}
        {/** Inicio de Fecha */}
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          gap={3}
          mt={2.5}
          mb={1}
        >
          <Tooltip
            aria-label="prev-month"
            title="Mes Anterior"
            color="secondary"
            onClick={handlePrevMonth}
            variant="contained"
          >
            <IconButton
              ria-label="prev-month"
              color="secondary"
              variant="contained"
              size="small"
              p={0}
              sx={{
                bgcolor: '#00AFEF',
                color: 'white',
                borderRadius: 2,
                boxShadow: 3,
              }}
            >
              <ArrowLeft />
            </IconButton>
          </Tooltip>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={locale}
          >
            <DatePicker
              views={['year', 'month']}
              value={selectedDate}
              onChange={handleDateChange}
              maxDate={new Date()}
              minDate={new Date().setFullYear(new Date().getFullYear() - 4)}
              sx={{
                cursor: 'pointer',
                backgroundColor: '#00AFEF',
                boxShadow: 3,
                borderRadius: 2,
                border: 'none',
                '& input': {
                  textTransform: 'uppercase',
                  color: 'white',
                  fontWeight: 'bold',
                  p: 0.85,
                  cursor: 'pointer',
                  textAlign: 'center',
                },
                '& button': {
                  color: 'white',
                  fontWeight: 'bold',
                },
                '& fieldset': {
                  border: 'none',
                },
              }}
            />
          </LocalizationProvider>
          <Tooltip aria-label="next-month" title="Mes Siguiente">
            <IconButton
              aria-label="next-month"
              color="secondary"
              size="small"
              p={0}
              sx={{
                bgcolor: '#00AFEF',
                color: 'white',
                borderRadius: 2,
                boxShadow: 3,
              }}
              disabled={
                currentMonth ===
                  (new Date().getMonth() + 1).toString().padStart(2, '0') &&
                year === new Date().getFullYear()
              }
              onClick={handleNextMonth}
              variant="contained"
            >
              <ArrowRight />
            </IconButton>
          </Tooltip>
        </Box>
        {/** Fin de Fecha */}
        {/** Inicio de Cards */}
        <Grid2 container={true} spacing={2} pt={2}>
          <Grid2 size={{ lg: 3, sm: 6, xs: 12 }}>
            <Card
              bgColor="#A53693"
              title={intl.formatMessage({
                id: 'app.chargeSolar.board.mainHead.consumtion',
              })}
              data={
                generalConsumes
                  ? `${generalConsumes?.consumes?.total_consume_kwh.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} kWh`
                  : null
              }
              footer={false}
              icon={
                <TrendingUp
                  sx={{
                    color: '#A53693',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
          <Grid2 size={{ lg: 3, sm: 6, xs: 12 }}>
            <Card
              bgColor="#00AFEF"
              title={intl.formatMessage({
                id: 'app.groupSolar.board.mainHead.maxDemand',
              })}
              data={
                generalConsumes
                  ? `${generalConsumes?.consumes?.demand_max.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} kW`
                  : null
              }
              footer={false}
              icon={
                <FlashOn
                  sx={{
                    color: '#00AFEF',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
          <Grid2 size={{ lg: 3, sm: 6, xs: 12 }}>
            <Card
              bgColor="#45B880"
              title={intl.formatMessage({
                id: 'app.chargeSolar.board.mainHead.estimAmtAsOfToday',
              })}
              data={
                generalConsumes?.consumes?.billing.total_average
                  ? formattedMoney(
                      generalConsumes?.consumes?.billing.total_average
                    )
                  : '$0.00'
              }
              footer={intl.formatMessage({
                id: 'app.charge.board.mainHead.estimAmtAsOfToday.vatNotice',
              })}
              icon={
                <AttachMoney
                  sx={{
                    color: '#45B880',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
          <Grid2 size={{ lg: 3, sm: 6, xs: 12 }}>
            <Card
              bgColor="#EAAB36"
              title="Historico"
              clicked={true}
              action={handleNavigation}
              data={' '}
              icon={
                <Receipt
                  sx={{
                    color: '#EAAB36',
                    width: '2rem',
                    height: '2rem',
                    fontSize: '2rem',
                  }}
                />
              }
            />
          </Grid2>
        </Grid2>
        {/** Fin de Cards */}
        {/** Inicio de Contenido */}
        <Grid2 container={true} spacing={2} pt={2}>
          <Grid2 size={{ lg: 9, md: 9, sm: 12, xs: 12 }}>
            <BarChart
              title={intl.formatMessage({
                id: 'app.chargeSolar.board.demandAndConsumpChart.title',
              })}
              custom={rate_horary === 1 ? 0 : 1}
              totalConsumeskW={totalConsumeskW}
              totalConsumeskWh={totalConsumeskWh}
            />
          </Grid2>
          <Grid2 size={{ lg: 3, md: 3, sm: 12, xs: 12 }}>
            <MostConsumeChart
              title={intl.formatMessage({
                id: 'app.chargeSolar.board.monthHighConsump.title',
              })}
              year={year}
              monthMostConsume={monthMostConsume}
            />
          </Grid2>
          <Grid2 size={{ lg: 9, md: 9, sm: 12, xs: 12 }}>
            <ComparativeYearConsumeChart
              title={intl.formatMessage({
                id: 'app.chargeSolar.board.difConsumpChart.title',
              })}
              year={year}
              dashboard={Dashboard.group}
              comparativeYearConsume={comparativeYearConsume}
            />
          </Grid2>
          <Grid2
            size={{ lg: 3, md: 3, sm: 12, xs: 12 }}
            display="flex"
            flexDirection="column"
            gap={2}
          >
            <DayWithMostConsumeChart
              title={intl.formatMessage({
                id: 'app.charge.board.highConsumDayCurrMonth.title',
              })}
              day={dayMostConsume.day}
              consume={dayMostConsume.consume}
              co2={dayMostConsume.co2}
            />
          </Grid2>
          <Grid2 size={12}>
            <DailyDemandReport
              rateHorary={rate_horary}
              updateMonth={currentMonth}
              updateYear={year}
            />
          </Grid2>
          <Grid2 size={12}>
            <GeneralReport
              title={intl.formatMessage({
                id: 'app.chargeSolar.board.demandPerDay.title',
              })}
              generalReport={generalReport.total_per_day_kw}
              updateYear={year}
              updateMonth={currentMonth}
              locale={localeNav}
              weather={weather ? weather : 0}
              legend={intl.formatMessage({
                id: 'app.chargeSolar.board.demandPerDay.dataSet.labels.demand',
              })}
              maxWeather={intl.formatMessage({
                id: 'app.charge.board.tempMax.title',
              })}
              minWeather={intl.formatMessage({
                id: 'app.charge.board.tempMin.title',
              })}
            />
          </Grid2>
          <Grid2 size={12}>
            <DailyConsumptionReport
              heatMap={heatMap}
              rateHorary={rate_horary}
              setHeatMap={setHeatMap}
              setValueInfo={setValueInfo}
              updateMonth={currentMonth}
              updateYear={year}
              valueInfo={valueInfo}
            />
          </Grid2>
          <Grid2 size={12}>
            <TotalsPerDay
              valueInfo={valueInfo}
              generalReport={generalReport.report}
              totalPerDay={generalReport.total_per_day}
              month={currentMonth}
              year={year}
            />
          </Grid2>
          <Grid2
            size={{
              lg: rate_horary === 0 ? 12 : valueInfo.kwh ? 7 : 6,
              xs: 12,
            }}
          >
            <AveragePerWeek
              valueInfo={valueInfo}
              totalsDaysOfWeek={generalReport.totals_days_of_week_hm}
              totalsDaysOfWeekCost={generalReport.cost_totals_days_of_week}
            />
          </Grid2>
          {rate_horary === 1 && (
            <Grid2 size={{ lg: valueInfo.kwh ? 5 : 6, xs: 12 }}>
              <TotalsPerTariff
                valueInfo={valueInfo}
                generalReport={generalReport.report}
                totalsPerHorary={generalReport.totals_per_horary}
                totalsPerHoraryCost={generalReport.totals_per_horary_price}
              />
            </Grid2>
          )}
          <Grid2 size={12}>
            <DailyConsume
              rateHorary={rate_horary}
              currentMonth={currentMonth}
              year={year}
              generalReport={generalReport.report}
            />
          </Grid2>
          <Grid2 size={12}>
            <ConsumeAccumulate
              totalProm={generalReport.total_prom_acomulate}
              totalPromLast={generalReport.total_prom_acomulate_last}
              totalPromTotals={generalReport.total_acomulate_totals}
              year={year}
              month={currentMonth}
            />
          </Grid2>
          <Grid2 size={12}>
            <GeneralReport
              title={intl.formatMessage({
                id: 'app.chargeSolar.board.consumationPerDay.title',
              })}
              generalReport={generalReport.total_per_day}
              updateYear={year}
              updateMonth={currentMonth}
              locale={localeNav}
              weather={weather ? weather : 0}
              legend={intl.formatMessage({
                id: 'app.chargeSolar.board.demandPerDay.dataSet.labels.demand',
              })}
              maxWeather={intl.formatMessage({
                id: 'app.charge.board.tempMax.title',
              })}
              minWeather={intl.formatMessage({
                id: 'app.charge.board.tempMin.title',
              })}
            />
          </Grid2>
          {weather && (
            <Grid2 size={12}>
              <Weather month={currentMonth} year={year} weather={weather} />
            </Grid2>
          )}
          <Grid2 size={12}>
            <OperationTime
              onOff={generalReport.onoff}
              year={year}
              month={currentMonth}
            />
          </Grid2>
          {chargeVoltageId && (
            <Grid2 size={{ lg: 4, md: 6, xs: 12 }}>
              <Voltage />
            </Grid2>
          )}
          <Grid2 size={{ lg: voltageValidation, md: 6, xs: 12 }}>
            <Current />
          </Grid2>
          {chargeVoltageId && (
            <Grid2 size={{ lg: voltageValidation, md: 12, xs: 12 }}>
              <Electric />
            </Grid2>
          )}
        </Grid2>
        {/** Fin de Contenido */}
      </Box>
      {/** Inicio de Modal */}
      <Dialog
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="sm"
        onClose={handleModal}
        open={openModal}
      >
        <DialogTitle>
          <Chip label="Recibos" />
        </DialogTitle>
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <FormControl component="fieldset" sx={{ marginTop: '10px' }}>
            <FormLabel component="legend" sx={{ textAlign: 'center' }}>
              Elige el Recibo a Descargar
            </FormLabel>
            <RadioGroup
              aria-label="report"
              name="report"
              onChange={handleRadioChange}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '50px',
              }}
              value={value}
            >
              <FormControlLabel
                control={<Radio />}
                label="Mensual"
                value="receipt"
              />
              <FormControlLabel
                control={<Radio />}
                label="Por Periodo"
                value="byPeriod"
              />
            </RadioGroup>
          </FormControl>
          {value === 'receipt' && (
            <Button
              color="primary"
              sx={{ marginTop: '10px' }}
              variant="contained"
              disabled={!receipt.success}
            >
              {receipt.success ? (
                <Link
                  download
                  style={{ textDecoration: 'none', color: 'white' }}
                  target="_blank"
                  to={receipt.data}
                >
                  {!loading ? 'Descargar Recibo' : 'Cargando...'}
                </Link>
              ) : (
                'Recibo aun no Disponible'
              )}
            </Button>
          )}
          {value === 'byPeriod' && (
            <Box alignItems="center" display="flex" flexDirection="column">
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={locale}
              >
                <DemoContainer components={['DatePicker', 'DatePicker']}>
                  <DateTimePicker
                    value={startDate}
                    label="Fecha inicial"
                    timeSteps={15}
                    maxDate={new Date()}
                    onChange={(newValue) => setStartDate(newValue)} // Convertir a dayjs
                  />
                  <DateTimePicker
                    value={endDate}
                    label="Fecha inicial"
                    timeSteps={15}
                    maxDate={new Date()}
                    maxTime={new Date()}
                    onChange={(newValue) => setEndDate(newValue)} // Convertir a dayjs
                  />
                </DemoContainer>
              </LocalizationProvider>
              <Button
                color="primary"
                onClick={handlePeriod}
                sx={{ marginTop: '10px' }}
                variant="contained"
              >
                Obtener datos
              </Button>
              {byPeriod && showInfo && (
                <Box
                  display="flex"
                  flexDirection="column"
                  gap="10px"
                  sx={{ marginTop: '10px' }}
                >
                  <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                  >
                    <Typography>Consumo:</Typography>
                    <Typography>
                      {byPeriod.totalKWh
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{' '}
                      kWh
                    </Typography>
                  </Box>
                  <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                  >
                    <Typography>Precio Medio:</Typography>
                    <Typography>{byPeriod.average.toFixed(2)} $/kWh</Typography>
                  </Box>
                  <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                  >
                    <Typography>Subtotal:</Typography>
                    <Typography>{formattedMoney(byPeriod.subtotal)}</Typography>
                  </Box>
                  <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                  >
                    <Typography>IVA:</Typography>
                    <Typography>{formattedMoney(byPeriod.iva)}</Typography>
                  </Box>
                  <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                  >
                    <Typography>Total:</Typography>
                    <Typography>{formattedMoney(byPeriod.total)}</Typography>
                  </Box>
                  <Typography
                    sx={{ marginTop: '10px', textAlign: 'center' }}
                    variant="h6"
                  >
                    ¿Deseas recibir el reporte por Whatsapp?
                  </Typography>
                  <TextField
                    fullWidth
                    slotProps={{
                      input: {
                        maxLength: countryCodes[country].maxLength,
                        startAdornment: (
                          <InputAdornment position="start">
                            <FormControl
                              variant="standard"
                              sx={{ border: 'none' }}
                            >
                              <Select
                                value={country}
                                onChange={handleCountryChange}
                                sx={{ border: 'none' }}
                              >
                                <MenuItem value="colombia">COL +57</MenuItem>
                                <MenuItem value="mexico">MX +52</MenuItem>
                              </Select>
                            </FormControl>
                          </InputAdornment>
                        ),
                      },
                    }}
                    label="Número Telefónico"
                    onChange={handlePhoneChange}
                    value={
                      formatPhone === 0 || formatDate > 5 ? 0 : formatPhone
                    }
                  />
                  <FormControl component="fieldset" sx={{ marginTop: '10px' }}>
                    <FormLabel component="legend" sx={{ textAlign: 'center' }}>
                      ¿Deseas recibir el reporte por Email?
                    </FormLabel>
                    <RadioGroup
                      aria-label="report"
                      name="report"
                      onChange={(e) => setSendEmail(e.target.value)}
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '50px',
                      }}
                      value={sendEmail}
                    >
                      <FormControlLabel
                        control={<Radio />}
                        label="Si"
                        value="yes"
                      />
                      <FormControlLabel
                        control={<Radio />}
                        label="No"
                        value="no"
                      />
                    </RadioGroup>
                  </FormControl>
                  {sendEmail === 'yes' && (
                    <TextField
                      fullWidth
                      label="Email"
                      onChange={(e) => setEmail(e.target.value)}
                      value={email === 0 ? '' : email}
                    />
                  )}
                  <Button
                    color="primary"
                    disabled={!isButtonEnabled()}
                    onClick={() => handleSendWhatsapp()}
                    sx={{ marginTop: '10px' }}
                    variant="contained"
                  >
                    Enviar Ticket Parcial
                  </Button>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={handleModal} variant="contained">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      {/** Fin de Modal */}
      {/** Inicio de Speed Dial */}
      {/* <SpeedDial
        ariaLabel="Screen Shot"
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32,
          '& .MuiFab-primary': {
            width: 80, // Ajusta el tamaño del botón principal
            height: 80,
            backgroundColor: 'rgb(198, 145, 0)', // Cambia el color de fondo
          },
        }}
        icon={<Print />}
      >
        <SpeedDialAction
          icon={<PictureAsPdf />}
          tooltipTitle="Imprimir en PDF"
          onClick={handleCapturePDF}
          sx={{
            backgroundColor: '#00AFEF',
            color: '#fff',
            width: '60px',
            height: '60px',
            fontSize: '1.5em',
            '&:hover': {
              backgroundColor: 'rgb(0, 146, 199)',
            },
          }}
        />
        <SpeedDialAction
          icon={<InsertPhoto />}
          tooltipTitle="Imprimir en Imagén"
          onClick={handleCapture}
          sx={{
            backgroundColor: '#00AFEF',
            color: '#fff',
            width: '60px',
            height: '60px',
            fontSize: '1.5em',
            '&:hover': {
              backgroundColor: 'rgb(0, 146, 199)',
            },
          }}
        />
      </SpeedDial> */}
      {/** Fin de Speed Dial */}
    </DashboardLayout>
  );
}
